const config = require('../../packages/tailwind/tailwind.config')

/** @type {import('tailwindcss').Config} */
module.exports = {
  ...config,
  content: [
    './pages/**/*.{ts,tsx}',
    './components/**/*.{ts,tsx}',
    '../../packages/components/src/**/*.{ts,tsx}',
    '../../packages/ui/src/**/*.{ts,tsx}'
  ],
  // Adding these here as tailwind is purging them even though the are used in the new usage charts
  safelist: [
    'bg-[#8b99ff]',
    'bg-[#B864F5]',
    'bg-[#64993D]',
    'bg-[#F66A0A]',
    'bg-[#FFC70A]',
    'bg-[#848C96]',
    'bg-[#1FE08C]',
    'bg-[#EB0C23]'
  ]
}
